'use client';

import { IconChevronDown } from '@actr/icons/chevron-down';
import { Button, ButtonSizes, ButtonTypes } from '@actr/ui/src/components/_atoms/button';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';

import * as Styled from './style.css';

export type AllFlightsProps = {
  title: string;
  flights: {
    name: string;
    url: string;
  }[] | null;
}

const AllFlights: React.FC<AllFlightsProps> = ({ title, flights }) => {
  const [hideShowMoreButton, setHideShowMoreButtonCount] = useState(false);

  function handleShowMoreButton() {
    setHideShowMoreButtonCount(true);
  }

  if (!flights) {
    return null;
  }

  return (
    <ContentBlock tagProps={{ itemScope: true, itemType: 'https://schema.org/ItemList' }}>
      <meta itemProp="numberOfItems" content={flights.length.toString()} />
      <Text tagName="h3" font="title.x2l" tagProps={{ itemProp: 'name' }}>{title}</Text>
      <div className={Styled.MainWrapper}>
        {flights.map((flight, index) => {
          const isHidden = !hideShowMoreButton && index > 24;
          const isMobileHidden = !hideShowMoreButton && index > 14;

          return (
            <div key={index} itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              <meta itemProp="position" content={(index + 1).toString()} />
              <a
                className={Styled.Flight({
                  isHidden,
                  isMobileHidden
                })}
                key={index}
                href={flight.url ? `/${flight.url}` : undefined}
                itemProp="url">
                <div itemProp="name">
                  {flight.name}
                </div>
              </a>
            </div>
          );
        })}
      </div>
      {!hideShowMoreButton && (
      <Button
        className={Styled.ShowMoreButton({
          flightsForDesktop: flights?.length < 25,
          flightsForMobile: flights?.length < 15
        })}
        onClick={handleShowMoreButton}
        rightIcons={<IconChevronDown />}
        buttonType={ButtonTypes.TERTIARY}
        size={ButtonSizes.S}>
        Еще рейсы
      </Button>
      )}
    </ContentBlock>
  );
};

export default observer(AllFlights);
